/*jshint esversion: 6 */
export let costOfLivingService = function (locale) {
    const url = import.meta.env.VITE_APP_COL_API_URL

    return {
        getQuestion: async () => {
            const response = await fetch(
                `${url}question_for_today?locale=${locale}`, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            return await response.json()
        },
        getTranslations: async () => {
            const response = await fetch(
                `${url}translations?locale=${locale}`, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            return await response.json()
        },
        getMiniSurvey: async () => {
            const response = await fetch(
                `${url}simplified-survey-json?rendertype=short&locale=${locale}`, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            const result = await response.json()
            return result;
        },
        getFullSurvey: async () => {
            const response = await fetch(
                `${url}simplified-survey-json?locale=${locale}`, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            const result = await response.json()
            return result;
        },
        postSurveyAnswers: async(values, surveyData, regionId) => {
            let payload = {
                ...values,
                'w20e.forms.process': 1,
                'w20e.forms.page': 'session_key',
                'session-id': surveyData['session-id'],
                session_key: surveyData.session_key,
                currency: surveyData.currency,
                latitude: surveyData.latitude,
                longitude: surveyData.longitude,
                geo_accuracy: surveyData.geo_accuracy,
                countrycode: surveyData.countrycode,
                region_chooser: regionId,
            }

            for (const [key, value] of Object.entries(payload)) {
                if (value === null) {
                    payload[key] = '';
                }
            }

            const params = new URLSearchParams(payload).toString();

            const response = await fetch(
                `${url}validate-survey?${params}`, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            // const result = await response.json()
            return response;
        }
    }
};

